/**
 * PGSS-5715: where a role lands when it is sent "home".
 *
 * Most roles go to `/` (which redirects to the dashboard). An Inventory Lookup login can reach exactly
 * one page, so sending it to `/` would leave it on a blank, denied route.
 *
 * Deliberately free of imports from app/auth/index so FuseAuthorization and userSlice can use it
 * without pulling in anything else.
 */

export const INVENTORY_LOOKUP_ROLE = 'inventory lookup';
export const INVENTORY_LOOKUP_HOME = '/inventory-lookup';

function roleList(userOrRole) {
  const role = userOrRole && typeof userOrRole === 'object' && !Array.isArray(userOrRole)
    ? userOrRole.role
    : userOrRole;
  if (Array.isArray(role)) return role.filter(Boolean);
  return role ? [role] : [];
}

/**
 * True when the user (or a bare role / role list) holds the Inventory Lookup role. Whatever other role it also
 * holds: the backend locks any holder of this role to the lookup endpoints (InventoryLookupLockdown), so the app
 * must treat it as a lookup login too, or it would show screens whose every call is refused.
 */
export function isInventoryLookupUser(userOrRole) {
  return roleList(userOrRole).includes(INVENTORY_LOOKUP_ROLE);
}

/** The route to send this role to when it lands on a page it cannot open; null means "the default". */
export function homeRouteFor(userRole) {
  return isInventoryLookupUser(userRole) ? INVENTORY_LOOKUP_HOME : null;
}
